import { render, staticRenderFns } from "./tags-table.vue?vue&type=template&id=26cd374c&scoped=true&"
import script from "./tags-table.vue?vue&type=script&lang=js&"
export * from "./tags-table.vue?vue&type=script&lang=js&"
import style0 from "./tags-table.vue?vue&type=style&index=0&id=26cd374c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cd374c",
  null
  
)

export default component.exports